module.exports = __webpack_public_path__ + "static/media/nav_admin.56d6ea45.svg";